import { Field, FieldProps } from 'formik';
import { Form, Input, Label } from 'semantic-ui-react';

interface AuthFieldProps {
    name: string;
    label: string;
    type?: string;
    placeholder?: string;
    autoComplete?: string;
    formProps?: any;
}

export const AuthField: React.FC<AuthFieldProps> = ({
    name,
    label,
    type = 'text',
    placeholder,
    autoComplete,
    ...props
}) => {
    return (
        <Field name={name}>
            {({ field, form, meta }: FieldProps) => (
                <Form.Field error={meta.touched && !!meta.error}>
                    {/* <label htmlFor={name}>{label}</label> */}
                    <Input
                        {...field}
                        id={name}
                        type={type}
                        placeholder={placeholder}
                        autoComplete={autoComplete}
                        error={meta.touched && !!meta.error}
                        fluid
                    />
                    {meta.touched && meta.error && (
                        <Label basic color="red" pointing>
                            {meta.error}
                        </Label>
                    )}
                </Form.Field>
            )}
        </Field>
    );
};